import { lowerFirst } from "lodash";
import { lru } from "tiny-lru";

import { UnauthorizedError } from "@/lib/fetchSingleton";

// With TTL (5 second expiration)
const cache = lru(50, 5000);

export function humanizeError(some: unknown, subject?: string) {
  let msg = subject ? `Cannot ${subject?.toLowerCase()} because: ` : "";

  if (some instanceof UnauthorizedError) {
    msg +=
      JSON.stringify(some) ||
      "Your session may have expired due to inactivity, or your token is invalid, please log in again";
  } else if (some instanceof Error) {
    msg += String(some);
  } else if (
    typeof some === "object" &&
    some !== null &&
    "status" in some &&
    some.status === "ERROR" &&
    "errors" in some &&
    Array.isArray(some.errors) &&
    typeof some.errors[0] === "object" &&
    some.errors[0] !== null &&
    typeof some.errors[0].message === "string"
  ) {
    msg += lowerFirst(some.errors[0].message);
  } else if (typeof some === "string") {
    msg = some;
  } else {
    msg = JSON.stringify(some);
  }

  // TODO: Refactor workaround
  // Current goal: prevent duplicate error messages (especially on token expiration).
  // Returning `undefined` suppresses the toast library from showing an error.
  // This is a temporary solution until a proper fix is implemented.
  if (cache.get(msg)) return undefined;

  cache.set(msg, msg);

  return msg;
}
